(() => {
  if (window.apSizeChartsReady) return;
  window.apSizeChartsReady = true;
  const dialog = document.getElementById('ap-size-chart-dialog');
  const template = document.getElementById('ap-size-chart-button-template');
  if (!dialog || !template) return;
  let opener;
  let previousOverflow;
  const close = () => dialog.close();
  const mount = () => {
    const product = document.querySelector('[id^="Product--"]');
    if (!product) return;
    const labels = product.querySelectorAll('.radio__legend__option-name, .select__label, label');
    const label = Array.from(labels).find(el => /^(suurus|size|dydis|tamanho)$/i.test(el.textContent.trim()));
    const legend = label?.closest('legend') || label?.closest('.selector-wrapper')?.querySelector('label');
    if (!legend || legend.querySelector('.ap-size-chart-link')) return;
    const button = template.content.firstElementChild.cloneNode(true);
    legend.classList.add('ap-size-chart-legend');
    legend.appendChild(button);
    button.addEventListener('click', () => {
      opener = button;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      dialog.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    });
  };
  dialog.querySelector('.ap-size-chart-close').addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog) {
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  }});
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    opener?.focus({ preventScroll: true });
  });
  mount();
  document.addEventListener('shopify:section:load', mount);
  const product = document.querySelector('[id^="Product--"]');
  if (product) new MutationObserver(mount).observe(product, { childList: true, subtree: true });
})();
